const SELECTOR = '.slider--opinions';
const CONFIG = {
    slidesPerView: 3,
    autoplay: {
        delay: 5000
    },
    loop: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    breakpoints: {
        768: {
            slidesPerView: 1
        },
        1024: {
            slidesPerView: 2
        }
    }
};

if (window.swiper) {
    document.querySelectorAll(SELECTOR).forEach(
        container => new window.swiper(
            container.querySelector('.swiper-container'),
            Object.assign(CONFIG, { pagination: { el: container.querySelector('.swiper-pagination') } })
        )
    );
}
